import {
  ContentUploadData,
  ExtraData,
  FinishTaskData,
  RecordData,
  SendMessageData
} from '@/apps/platform/types/task'
import { api_post, single_post, stringfy_post } from '../utils/http'
import { URLS } from './constant'

const clone = (item) => JSON.parse(JSON.stringify(item))

const taskListColumns = [
  {
    title: '任务 ID',
    dataIndex: 'task_id',
    scopedSlots: { customRender: 'task_id' }
  },
  {
    title: '任务名称',
    dataIndex: 'task_name'
  },
  {
    title: '资源来源',
    dataIndex: 'business_type'
  },
  {
    title: '学科',
    dataIndex: 'subject_id'
  },
  {
    title: '分类',
    dataIndex: 'category_name'
  },
  {
    title: '任务分配时间',
    dataIndex: 'created_at'
  },
  {
    title: '已完成资源数/资源总数',
    dataIndex: 'resource_info'
  }
]

const subListColumns = [
  {
    title: '审核 ID',
    dataIndex: 'relate_id'
  },
  {
    title: '资源 ID',
    dataIndex: 'resource_id'
  },
  {
    title: '审核类型',
    dataIndex: 'type'
  },
  {
    title: '剩余时效',
    dataIndex: 'deadline'
  },
  {
    title: '审核状态',
    dataIndex: 'status'
  },
  {
    title: '操作',
    dataIndex: 'operation',
    scopedSlots: { customRender: 'operation' }
  }
]

async function getTaskList(
  page_num = 1,
  page_size: number
): Promise<{
  count: number
  current_page: number
  data: any[]
}> {
  const retData = await stringfy_post(URLS.GET_MY_TASK_LIST, { page_num, page_size }).then(
    (retData) => {
      if (retData.success) {
        return retData
      } else {
        return {
          count: 0,
          current_page: 1,
          data: []
        }
      }
    }
  )
  return retData
}

async function getSubTaskList(
  parent_id: string,
  page_num = 1,
  page_size: number
): Promise<{ count: number; current_page: number; contents: any[] }> {
  const retData = await stringfy_post(URLS.GET_SUB_TASK, {
    parent_id,
    only_unfinished: 1,
    page_num,
    page_size
  }).then((retData) => {
    if (retData.success || retData.status) {
      return retData.data
    } else {
      return {
        count: 0,
        current_page: 1,
        contents: []
      }
    }
  })
  return retData
}

async function getTaskInstance(instance_id: string) {
  const retData = await stringfy_post(URLS.GET_SUB_TASK_INSTANCE, { instance_id }).then(
    (retData) => {
      if (retData.success) {
        return retData.data
      } else {
        return {}
      }
    }
  )
  return retData
}

async function saveExtraData(data: ExtraData) {
  let temp = clone(data) as ExtraData
  temp.word_data = temp.word_data.filter(
    (word) => word.word_name != '' || word.sensitive_type.length != 0
  )
  // 如果没有存在有效content字段的子项，则置空
  if (temp.content_data.filter((item) => !!item.content).length == 0) {
    temp.content_data = []
  }
  let retData = await stringfy_post(URLS.SAVE_EXTRA_DATA, temp)
  return retData
}

async function sendMessage(data: SendMessageData) {
  let retData = await stringfy_post(URLS.SEND_MESSAGE, data)
  return retData
}

async function finishTask(data: FinishTaskData) {
  let retData = await stringfy_post(URLS.FINISH_TASK, data)
  return retData
}

async function contentUpload(data: ContentUploadData) {
  let retData = await stringfy_post(URLS.CONTENT_UPLOAD, data)
  return retData
}

const STAGES = {
  STAGE1: ['process_000000003973', 'process_000000010898'], // 一审流程
  STAGE2: ['process_000000004160', 'process_000000011746'] // 二审流程
}

/*
内容审核流程：
内容审核流程包括2个流程，分别为内容一审流程和内容二审流程
一审流程定义的id为process_000000003973，包括7个节点：
节点1，node_id为1，名称:一级审核     (审核节点)
节点2，node_id为2，名称:资源处理    （录入节点）
节点3，node_id为3，名称:一级复审    （审核节点）
节点4：node_id为4，名称:一级审核通过  (结束节点)
节点5：node_id为5，名称:一级审核升级 （结束节点）
节点6：node_id为6，名称:一级复审通过 （结束节点）
节点7：node_id为7，名称:一节复审升级 （结束节点）

二审流程定义的id为process_000000004160，包括5个节点：
节点1，node_id为1，名称:二级审核     (审核节点)
节点2，node_id为2，名称:资源处理    （录入节点）
节点3，node_id为3，名称:二级复审    （审核节点）
节点4：node_id为4，名称:二级审核通过  (结束节点)
节点5：node_id为5，名称:二级审核升级 （结束节点）

 */

const STEPS = {
  STEP1: '1',
  STEP2: '2',
  STEP3: '3'
}

/**
 * 批量确认通过
 */
async function apiBatchConfirmContentModify() {
  return stringfy_post(URLS.CONTENT_BATCH_CONFIRM_MODIFY, {})
}

/**
 * 记录任务处理时间流
 */
async function recordFinishTime(data: RecordData) {
  return single_post(URLS.RECORD_FINISH_TIME, data)
}

/**
 *
 */
function getFullText(data: { instance_id: string }) {
  return stringfy_post(URLS.GET_FULL_TEXT, data)
}

export {
  taskListColumns,
  getTaskList,
  getSubTaskList,
  subListColumns,
  STAGES,
  STEPS,
  getTaskInstance,
  saveExtraData,
  sendMessage,
  finishTask,
  contentUpload,
  apiBatchConfirmContentModify,
  recordFinishTime,
  getFullText
}
